import { IStuHoSoSinhVienViewModel } from "./../../../model/respone/category/IStuHoSoSinhVienViewModel";
import { IBienLaiThuCreateRequest } from "../../../model/request/bien-lai/IBienLaiThuCreateRequest";
import { IBienLaiThuHinhThucNopViewModel } from "../../../model/respone/chung-tu/IBienLaiThuHinhThucNopViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
import { IThuPhiTamThuTab } from "../../../model/request/thu-phi-tam-thu/IThuPhiTamThu";
import { IMucThuTamThuSinhVienViewModel } from "../../../model/respone/chung-tu-tam-thu/IMucThuTamThuSinhVienViewModel";
import { IMucThuTamThuSinhVienSelectRequest } from "../../../model/request/chung-tu-tam-thu/IMucThuTamThuSinhVienSelectRequest";
export interface IThuPhiTamThuHocSinhTabActionTyes<T> {
  request: IMucThuTamThuSinhVienSelectRequest;
  data: T;
}

export const eThuPhiTamThuActionsObj = {
  ADD_NEW_TAB: {} as undefined | IStuHoSoSinhVienViewModel,
  REMOVE_TAB: "",
  UPDATE_TAB_DATA: {} as IThuPhiTamThuTab,
  CHANGEG_SELECTED_TAB: "",

  ADD_NEW_TAB_BY_ID: "",
  ADD_NEW_TAB_BY_ID_ERROR: "",

  LOAD_MUC_THU_START: {} as IMucThuTamThuSinhVienSelectRequest,
  LOAD_MUC_THU_SUCCESS: {} as IThuPhiTamThuHocSinhTabActionTyes<
    IMucThuTamThuSinhVienViewModel[]
  >,
  LOAD_MUC_THU_ERROR: {} as IThuPhiTamThuHocSinhTabActionTyes<string>,
  CHANGE_MUC_THU_SELECTED_IDs: {} as IThuPhiTamThuHocSinhTabActionTyes<
    number[]
  >,
  CHANGE_STEP: {} as IThuPhiTamThuHocSinhTabActionTyes<number>,
  CHANGE_HINHTHUCNOP: {} as IThuPhiTamThuHocSinhTabActionTyes<
    IBienLaiThuHinhThucNopViewModel[]
  >,
  CHANGE_SO_TIEN_THUC_NOP: {} as IThuPhiTamThuHocSinhTabActionTyes<number>,
  CREATE_BIENLAITHU_START: {} as IBienLaiThuCreateRequest,
  CREATE_BIENLAITHU_SUCCESS: {} as IThuPhiTamThuHocSinhTabActionTyes<number>,
  CREATE_BIENLAITHU_ERROR: {} as IThuPhiTamThuHocSinhTabActionTyes<string>,
  CHANGE_THONGTINBIENLAI: {} as IThuPhiTamThuHocSinhTabActionTyes<any>,
};
export const eThuPhiTamThuActionIds = generateActionTypeIds(
  eThuPhiTamThuActionsObj,
  "THU_PHI_TAM_THU"
);
export type IThuPhiTamThuActionTypes = IGenericActionType<
  typeof eThuPhiTamThuActionsObj,
  "THU_PHI_TAM_THU"
>;
